<template>
  <div class="menu-wrapper">
    <template v-for="item in leilist">
      <router-link :to="item.path" :key="item.meta.name" v-if="!item.children">
        <el-menu-item :index="item.path" :class="{'submenu-title-noDropdown':!isNest}" @click="menuClik(item)">
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.meta.title||item.path" :key="item.meta.title" v-else>
        <template slot="title">
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta.title }}</span>
        </template>
        <template v-for="child in item.children">
          <router-link :to="child.path" :key="child.meta.title">
            <!-- -->
            <el-menu-item :index="child.path" @click="menuClik(child)">
              <img v-if="child.meta.title=='公众号管理'" src="../../../../assets/image/whitewe.png" alt=""
                   style="margin-right: 10px;margin-left: 5px;">
              <i :class="child.meta.icon"></i>
              <span slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { findValue } from '@/utils/pawer'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leilist: [],
    }
  },
  watch: {
    '$route.path'(path) {
      this.syncMenuIdByPath(path)
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    menuClik(val) {
      if (val) {
        localStorage.setItem("Menuids", val.id);
      }
    },
    syncMenuIdByPath(path) {
      if (!this.leilist || !this.leilist.length || !path) return
      const matched = findValue(this.leilist, path)
      if (matched && matched.id != null) {
        localStorage.setItem("Menuids", matched.id)
      }
    },
    getlist() {
      this.$api.get('/sys/permission/getUserPermissionByToken').then((res) => {
        if (res.data.success === true) {
          this.leilist = res.data.result.menu;
          // 按当前路由同步 Menuids，禁止写死为第一个菜单（刷新会拿错按钮权限）
          this.syncMenuIdByPath(this.$route.path)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue